import request from "@/plugins/axios"
//上传汇总任务
let prefix = "eids-invoice/tcs/uploadTaskFile";


/**
 * 查询文件列表
 * @param {} taskId 
 * @returns 
 */
export function list(taskId) {
  return request({
    url: prefix + '/obtainByTask/'+taskId,
    method: 'get'
    
  })
}
//更新任务为已完成
export function update(taskId) {
  return request({
    url: prefix + '/update/'+taskId,
    method: 'get',
  })
}
export function remove(criteria) {
  return request({
    url: prefix + '/delete',
    method: 'post',
    data: criteria
  })
}

export function getFileInfo(fileId) {
  return request({
    url:  'eids-invoice/file/info/'+fileId,
    method: 'get'
  })
}



